// src/actions/types.js

// --- Gallery (Artwork) ---
export const FETCH_GALLERY_REQUEST = "FETCH_GALLERY_REQUEST";
export const FETCH_GALLERY_SUCCESS = "FETCH_GALLERY_SUCCESS";
export const FETCH_GALLERY_FAILURE = "FETCH_GALLERY_FAILURE";

export const CREATE_ARTWORK_REQUEST = "CREATE_ARTWORK_REQUEST";
export const CREATE_ARTWORK_SUCCESS = "CREATE_ARTWORK_SUCCESS";
export const CREATE_ARTWORK_FAILURE = "CREATE_ARTWORK_FAILURE";

export const UPDATE_ARTWORK_REQUEST = "UPDATE_ARTWORK_REQUEST";
export const UPDATE_ARTWORK_SUCCESS = "UPDATE_ARTWORK_SUCCESS";
export const UPDATE_ARTWORK_FAILURE = "UPDATE_ARTWORK_FAILURE";

export const DELETE_ARTWORK_REQUEST = "DELETE_ARTWORK_REQUEST";
export const DELETE_ARTWORK_SUCCESS = "DELETE_ARTWORK_SUCCESS";
export const DELETE_ARTWORK_FAILURE = "DELETE_ARTWORK_FAILURE";

export const SELECT_ARTWORK = "SELECT_ARTWORK";
export const CLEAR_SELECTED_ARTWORK = "CLEAR_SELECTED_ARTWORK";

// --- Artist Profile ---
export const FETCH_ARTIST_PROFILE_REQUEST = "FETCH_ARTIST_PROFILE_REQUEST";
export const FETCH_ARTIST_PROFILE_SUCCESS = "FETCH_ARTIST_PROFILE_SUCCESS";
export const FETCH_ARTIST_PROFILE_FAILURE = "FETCH_ARTIST_PROFILE_FAILURE";

export const UPDATE_ARTIST_PROFILE_REQUEST = "UPDATE_ARTIST_PROFILE_REQUEST";
export const UPDATE_ARTIST_PROFILE_SUCCESS = "UPDATE_ARTIST_PROFILE_SUCCESS";
export const UPDATE_ARTIST_PROFILE_FAILURE = "UPDATE_ARTIST_PROFILE_FAILURE";

// --- Library Card (Brand Kit / DDB generic store) ---
export const GET_LIBRARY_CARD_REQUEST = "GET_LIBRARY_CARD_REQUEST";
export const GET_LIBRARY_CARD_SUCCESS = "GET_LIBRARY_CARD_SUCCESS";
export const GET_LIBRARY_CARD_FAILURE = "GET_LIBRARY_CARD_FAILURE";

export const UPDATE_LIBRARY_CARD_REQUEST = "UPDATE_LIBRARY_CARD_REQUEST";
export const UPDATE_LIBRARY_CARD_SUCCESS = "UPDATE_LIBRARY_CARD_SUCCESS";
export const UPDATE_LIBRARY_CARD_FAILURE = "UPDATE_LIBRARY_CARD_FAILURE";

export const REQUEST_PRESIGNED_URL = "REQUEST_PRESIGNED_URL";
export const REQUEST_PRESIGNED_URL_SUCCESS = "REQUEST_PRESIGNED_URL_SUCCESS";
export const REQUEST_PRESIGNED_URL_FAILURE = "REQUEST_PRESIGNED_URL_FAILURE";

// --- Store Items ---
export const FETCH_STORE_REQUEST = "FETCH_STORE_REQUEST";
export const FETCH_STORE_SUCCESS = "FETCH_STORE_SUCCESS";
export const FETCH_STORE_FAILURE = "FETCH_STORE_FAILURE";

export const CREATE_STORE_ITEM_REQUEST = "CREATE_STORE_ITEM_REQUEST";
export const CREATE_STORE_ITEM_SUCCESS = "CREATE_STORE_ITEM_SUCCESS";
export const CREATE_STORE_ITEM_FAILURE = "CREATE_STORE_ITEM_FAILURE";

export const UPDATE_STORE_ITEM_REQUEST = "UPDATE_STORE_ITEM_REQUEST";
export const UPDATE_STORE_ITEM_SUCCESS = "UPDATE_STORE_ITEM_SUCCESS";
export const UPDATE_STORE_ITEM_FAILURE = "UPDATE_STORE_ITEM_FAILURE";

export const DELETE_STORE_ITEM_REQUEST = "DELETE_STORE_ITEM_REQUEST";
export const DELETE_STORE_ITEM_SUCCESS = "DELETE_STORE_ITEM_SUCCESS";
export const DELETE_STORE_ITEM_FAILURE = "DELETE_STORE_ITEM_FAILURE";

// --- Blog Posts ---
export const FETCH_BLOGS_REQUEST = "FETCH_BLOGS_REQUEST";
export const FETCH_BLOGS_SUCCESS = "FETCH_BLOGS_SUCCESS";
export const FETCH_BLOGS_FAILURE = "FETCH_BLOGS_FAILURE";

export const SAVE_BLOG_REQUEST = "SAVE_BLOG_REQUEST";
export const SAVE_BLOG_SUCCESS = "SAVE_BLOG_SUCCESS";
export const SAVE_BLOG_FAILURE = "SAVE_BLOG_FAILURE";

export const DELETE_BLOG_REQUEST = "DELETE_BLOG_REQUEST";
export const DELETE_BLOG_SUCCESS = "DELETE_BLOG_SUCCESS";
export const DELETE_BLOG_FAILURE = "DELETE_BLOG_FAILURE";

// --- Collections ---
export const FETCH_COLLECTIONS_REQUEST = "FETCH_COLLECTIONS_REQUEST";
export const FETCH_COLLECTIONS_SUCCESS = "FETCH_COLLECTIONS_SUCCESS";
export const FETCH_COLLECTIONS_FAILURE = "FETCH_COLLECTIONS_FAILURE";

export const CREATE_COLLECTION_REQUEST = "CREATE_COLLECTION_REQUEST";
export const CREATE_COLLECTION_SUCCESS = "CREATE_COLLECTION_SUCCESS";
export const CREATE_COLLECTION_FAILURE = "CREATE_COLLECTION_FAILURE";

export const UPDATE_COLLECTION_REQUEST = "UPDATE_COLLECTION_REQUEST";
export const UPDATE_COLLECTION_SUCCESS = "UPDATE_COLLECTION_SUCCESS";
export const UPDATE_COLLECTION_FAILURE = "UPDATE_COLLECTION_FAILURE";

export const DELETE_COLLECTION_REQUEST = "DELETE_COLLECTION_REQUEST";
export const DELETE_COLLECTION_SUCCESS = "DELETE_COLLECTION_SUCCESS";
export const DELETE_COLLECTION_FAILURE = "DELETE_COLLECTION_FAILURE";
